var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0178 2.07692C21.1928 2.49231 20.3678 2.63077 19.4053 2.76923C20.3678 2.21538 21.0553 1.38462 21.3303 0.276923C20.5053 0.830769 19.5428 1.10769 18.4428 1.38462C17.6178 0.553846 16.3803 0 15.1428 0C12.2553 0 10.0553 2.76923 10.7428 5.53846C7.03032 5.4 3.73032 3.6 1.39282 0.83077C0.155322 2.90769 0.842822 5.53846 2.76782 6.92308C2.08032 6.92308 1.39282 6.64615 0.705322 6.36923C0.705322 8.44615 2.21782 10.3846 4.28032 10.9385C3.59282 11.0769 2.90532 11.2154 2.21782 11.0769C2.76782 12.8769 4.41782 14.2615 6.48032 14.2615C4.83032 15.5077 2.35532 16.2 0.0178223 15.9231C2.08032 17.1692 4.41782 18 6.89282 18C15.2803 18 19.9553 10.9385 19.6803 4.43077C20.6428 3.87692 21.4678 3.04615 22.0178 2.07692Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b6f0b1d69d72c185b9f229730ec30550.svg";
export { ForwardRef as ReactComponent };